<h1 mat-dialog-title>{{this.data.dataModal.tag | translate}}</h1>
<div mat-dialog-content>
  <p>{{this.data.dataModal.preg | translate}}</p>
  <mat-select class="selectLangs" placeholder="{{'CERTIFICAR.IDIOMAS.CARD1.MODAL.PLACELISTA' | translate}}"
    *ngIf="this.data.dataModal.langDestino == 1">
    <mat-option *ngFor="let lang of langs" [value]="lang.id" (click)="selLangId(lang,this.data.dataModal.langDestino)">
      {{lang.nombre}}
    </mat-option>
  </mat-select>

  <ng-container *ngIf="this.data.dataModal.langDestino == 2" >
    <!-- <mat-checkbox *ngFor="let lang of langs" class="cbAdLang" [value]="lang.id" (click)="selLangIdAd(lang,this.data.dataModal.langDestino)">
      {{lang.nombre}}
    </mat-checkbox> -->

    <mat-list>
      <mat-list-item *ngFor="let lang of langs; last as last">

        <mat-checkbox [value]="lang.id" (click)="selLangIdAd(lang,this.data.dataModal.langDestino)">
          <h4 mat-line>{{lang.nombre}}</h4>
        </mat-checkbox>

        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>

  </ng-container>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{'CERTIFICAR.IDIOMAS.CARD1.MODAL.BOTONES.BACK' | translate}}</button>
  <button mat-button *ngIf="this.data.dataModal.langDestino == 1" [mat-dialog-close]="langIdSel" [disabled]="!langBool">
    {{'CERTIFICAR.IDIOMAS.CARD1.MODAL.BOTONES.OK' | translate}}
  </button>
  <button mat-button *ngIf="this.data.dataModal.langDestino == 2" [mat-dialog-close]="langIdSelAdic">
    {{'CERTIFICAR.IDIOMAS.CARD1.MODAL.BOTONES.OK' | translate}}
  </button>
</div>
